import React from "react"
import { quoteWrapper } from "./quote.module.css"
import RichTextContent from "../rich-text-content"

const QuoteEmbed = ({ data }) => {


    return (
        <aside className={quoteWrapper}>

            <RichTextContent content={data.body} />

        </aside>
    )
}

export default QuoteEmbed
